import Reconciliation from "./reconciliation";

export const ReconciliationConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth    : ['super', 'staff', 'inbound'],
    routes  : [
        {
            path     : '/reconciliation',
            component: Reconciliation
        }
    ]
};
